module.exports = __webpack_public_path__ + "static/ForThePeople0-c58f637feb78ee5c138e24e9d2b15208.webp";